function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.98 44.3A299.27 299.27 0 018.22 30.55l-4.49-4.74-.05-.06-.82-.91c-4.08-5.1-3.8-13.16.88-17.83a12.77 12.77 0 0118.05 0l2.32 2.32 2.1-2.1a12.77 12.77 0 0118.05 0c4.98 4.98 4.98 13.82.03 18.78a230.07 230.07 0 01-19.07 18.3 1.7 1.7 0 01-2.23 0zm1.13-3.53l3.79-3.36c4.26-3.84 8.38-7.82 12.31-12h-9.7l-3.15 6.4a1.7 1.7 0 01-3.1-.12l-4.08-10.43-1.5 3.18c-.28.59-.88.97-1.53.97H7.97c3.81 4.06 8.02 8.05 12.3 11.92l3.84 3.43zm1.9-13.9l1.92-3.9a1.7 1.7 0 011.52-.95h13.68c2.32-3.8 1.9-9.23-1.27-12.4a9.37 9.37 0 00-13.25 0l-3.3 3.3a1.7 1.7 0 01-2.4 0l-3.52-3.51a9.38 9.38 0 00-13.25 0C2.9 12.64 2.53 18.23 5 22h11.07l2.73-5.76a1.7 1.7 0 013.1.1l4.11 10.51z"
})));